import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

/**
 * Loading placeholder for the Team Workload page body (cases + investigations).
 *
 * Mirrors the real layout below the page header: a 2×2 grid of summary cards
 * (each with a title row and a couple of member rows) and a team section below.
 * The page keeps its real sub-header visible while this renders.
 */
@Component({
  selector: 'cm-skeleton-team-workload',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-team-workload.component.html',
  styleUrl: './skeleton-team-workload.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonTeamWorkloadComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');

  /** Summary cards rendered in the 2×2 grid. */
  public readonly cardCount = input<number>(4);

  /** Placeholder member rows shown inside each summary card. */
  public readonly rowsPerCard = input<number>(3);

  /** Placeholder member rows shown inside the team section. */
  public readonly teamRows = input<number>(4);
}
